import { render, staticRenderFns } from "./render_number.vue?vue&type=template&id=60c1b3d8&scoped=true&"
import script from "./render_number.vue?vue&type=script&lang=js&"
export * from "./render_number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c1b3d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c1b3d8')) {
      api.createRecord('60c1b3d8', component.options)
    } else {
      api.reload('60c1b3d8', component.options)
    }
    module.hot.accept("./render_number.vue?vue&type=template&id=60c1b3d8&scoped=true&", function () {
      api.rerender('60c1b3d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/render_fields/render_number.vue"
export default component.exports